export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'

export const ARCH_CLEAR = 'ARCH_CLEAR'
export const ARCH_UPDATE = 'ARCH_UPDATE'